import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from '@nuxtjs/composition-api';
import { onClickOutside, useWindowScroll } from '@vueuse/core';
import { useLanguages } from '~/composables';

interface Props {
  dark?: boolean;
  triggerTextClasses?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSwitcher',
  props: {
    dark: { type: Boolean, default: true },
    triggerTextClasses: { default: '' }
  },
  setup(__props: any) {



const { languages, currentLanguage } = useLanguages();
const isOpen = ref(false);

const availableLanguages = computed(() =>
  languages.filter(
    (language: { code: string; default: boolean; name: string }) =>
      !['lv', 'lt', 'et'].includes(language.code),
  ),
);

const close = () => {
  if (isOpen.value === false) return;
  isOpen.value = false;
};

const toggle = () => {
  isOpen.value = !isOpen.value;
};

const { y } = useWindowScroll();

const target = ref(null);

onClickOutside(target, () => {
  close();
});

watch(y, () => {
  close();
});

watch(currentLanguage, (value) => value && close());

return { __sfc: true,languages, currentLanguage, isOpen, availableLanguages, close, toggle, y, target }
}

})